import { render, staticRenderFns } from "./TicketsBadges.vue?vue&type=template&id=50aec0f9"
import script from "./TicketsBadges.vue?vue&type=script&lang=js"
export * from "./TicketsBadges.vue?vue&type=script&lang=js"
import style0 from "./TicketsBadges.vue?vue&type=style&index=0&id=50aec0f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports